<template>
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title">
        Move item{{ id ? '' : 's' }} to
      </p>
      <button
        type="button"
        class="delete"
        @click="$emit('close')" />
    </header>
    <section class="modal-card-body">
      <ul class="collections-list">
        <CollectionsList
          @clicked-on="selectCollection"
          :selectedCollection="selectedCollection" />
      </ul>
    </section>
    <footer class="modal-card-foot">
      <button
        class="button"
        type="button"
        @click="$emit('close')">
        Cancel
      </button>
      <button
        class="button is-primary"
        @click="confirmMove">
        Move
      </button>
    </footer>
  </div>
</template>

<script>
import CollectionsList from '@/components/AppView/CollectionView/CollectionsList.vue';

export default {
  name: 'ModalMove',
  props: {
    id: Number,
  },
  data() {
    return {
      selectedCollection: null,
    };
  },
  components: {
    CollectionsList,
  },
  methods: {
    selectCollection(id) {
      this.selectedCollection = id;
    },
    confirmMove() {
      if (!this.selectedCollection) return;
      this.$emit('move', this.selectedCollection, this.id);
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~styles/colors';

.collections-list {
  position: relative;
  width: 20vw;
  height: 40vh;
  padding: 0.5rem 0;
  background-color: #ffffff;
  list-style: none;
  overflow-y: auto;
}
.button {
  height: 100%;
  width: 50%;
}
</style>
